
import inventoryAxiosInstance from "../utils/inventory.axios";

export default class InventoryServiceHelper {
    static async handleGetRequest(url, headers = null) {
        try {
            const res = await inventoryAxiosInstance.get(url, headers);
            return res.data;
        } catch (error) {
            throw error
        }
    }

    static async handlePostRequest(url, payload, headers = null) {
        try {
            const res = await inventoryAxiosInstance.post(url, payload, headers);
            return res.data;
        } catch (error) {
            throw error;
        }
    }

    static async handlePatchRequest(url, payload, headers = null) {
        try {
            const res = await inventoryAxiosInstance.patch(url, payload, headers)
            return res.data;
        } catch (error) {
            throw error;
        }
    }
    static async handlePutRequest(url, payload, headers = null) {
        try {
            const res = await inventoryAxiosInstance.put(url, payload, headers)
            return res.data;
        } catch (error) {
            throw error;
        }
    }
    static async handleDeleteRequest(url, headers = null) {
        try {
            const res = await inventoryAxiosInstance.delete(url, headers)
            return res.data;
        } catch (error) {
            throw error;
        }
    }

    static async handleDownloadRequest(url, filename = 'report.xlsx') {
        try {
            const res = await inventoryAxiosInstance.get(url, {
                responseType: 'blob',
            });

            const blob = new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            const downloadUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = filename; 

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);

            return res.data;
        } catch (error) {
            throw error;
        }
    }
}